const toggleBackModal = () => ({
  type: 'TOGGLE_BACK_MODAL',
})

export { toggleBackModal }
